import Widget from './containers/Widget/Widget';

export {
    Widget,
};
export default Widget;
